import { BUTTON_BORDER_RADIUS } from "Constants/theme";

export const getMuiButtonRootStyles = ({ ownerState = {} } = {}) => ({
  borderRadius: BUTTON_BORDER_RADIUS,
  transition:
    "transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
  "&:hover": {
    transform: "translateY(-1px)",
  },
  ...(ownerState.fullWidth
    ? {}
    : {
        width: "fit-content",
        height: "fit-content",
      }),
});

export const getMuiDisabledStyles = (theme) => ({
  "&.Mui-disabled": {
    "&.Mui-disabled": {
      backgroundColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled,
      boxShadow: "none",
      opacity: 1,
    },
  },
});

export const muiSnackbarDefaultProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
};
